import React from 'react';

export const IconLoadFile = () => (
    <svg
        width="16"
        height="16"
        style={{ display: 'block' }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 12C12.5 12.8284 11.8284 13.5 11 13.5H5C4.17157 13.5 3.5 12.8284 3.5 12L3.5 4C3.5 3.17157 4.17157 2.5 5 2.5L7.75736 2.5C8.15518 2.5 8.53672 2.65804 8.81802 2.93934L12.0607 6.18198C12.342 6.46328 12.5 6.84482 12.5 7.24264V12ZM13.1213 5.12132C13.6839 5.68393 14 6.44699 14 7.24264L14 12C14 13.6569 12.6569 15 11 15H5C3.34315 15 2 13.6569 2 12V4C2 2.34315 3.34315 1 5 1H7.75736C8.55301 1 9.31607 1.31607 9.87868 1.87868L13.1213 5.12132ZM5.46967 8.71967C5.17678 9.01256 5.17678 9.48744 5.46967 9.78033C5.76256 10.0732 6.23744 10.0732 6.53033 9.78033L7.25 9.06066V11.25C7.25 11.6642 7.58579 12 8 12C8.41421 12 8.75 11.6642 8.75 11.25V9.06066L9.46967 9.78033C9.76256 10.0732 10.2374 10.0732 10.5303 9.78033C10.8232 9.48744 10.8232 9.01256 10.5303 8.71967L8.53033 6.71967C8.23744 6.42678 7.76256 6.42678 7.46967 6.71967L5.46967 8.71967Z"
            fill="currentColor"
        />
    </svg>
);
